import { adminGetProjectFilesDowloadUrl } from '@utils/api';
import pLimit from 'p-limit';

export const downloadProjectFiles = async (project_uuid, path = 'images/') => {
	return new Promise(async (resolve, reject) => {
		const limit = pLimit(5);
		try {
			const fileEntries = Object.entries(
				await adminGetProjectFilesDowloadUrl(project_uuid, path)
			);

			if (!fileEntries.length)
				return reject(
					`No images to download found in s3 bucket: ${path}`
				);

			const promises = [];
			for (const [key, url] of fileEntries)
				promises.push(limit(async () => downloadFile(key, url)));

			await Promise.all(promises);
			resolve('All images downloaded successfully.');
		} catch (error) {
			limit.clearQueue();
			console.error(error);
			reject(
				'Something went wrong while downloading the images. Check the console for more details.'
			);
		}
	});
};

export const downloadFile = async (key, signed_url) => {
	const fileName = key.split('/').pop();
	console.log('%c⬇️ Downloading: ', 'color: #EABDC4', fileName);

	return new Promise(async (resolve, reject) => {
		try {
			const response = await fetch(signed_url);
			if (!response.ok) throw new Error('Network response was not ok');

			const blob = await response.blob();
			const a = document.createElement('a');
			const url = URL.createObjectURL(blob);
			a.href = url;
			a.download = fileName;
			document.body.appendChild(a);
			a.click();
			window.URL.revokeObjectURL(url);
			a.remove();

			resolve(`Downloaded ${fileName}`);
		} catch (error) {
			console.error(error);
			reject(
				`Failed to download file ${fileName}. Check the console for more information.`
			);
		}
	});
};
